<template>
  <table-view
    :total="total"
    :query-info.sync="queryInfo"
    @reload-table="renderTable"
  >
    <template #header>
      <view-search-form
        ref="searchFormRef"
        :queryInfo.sync="queryInfo"
        :tool-list="['grade', 'campus']"
        @on-search="renderTable(1)">
        <el-form-item label="所在楼栋" prop="dormitoryId">
          <el-select v-model="queryInfo.dormitoryId" clearable size="small" :disabled="!dormBuildList.length">
            <el-option
              v-for="{dormitoryName, id} in dormBuildList"
              :label="dormitoryName"
              :value="id"
              :key="id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否绑定学生">
          <el-select v-model="queryInfo.bindType" clearable size="small">
            <el-option label="已绑定" :value="1" />
            <el-option label="未绑定" :value="0" />
          </el-select>
        </el-form-item>
      </view-search-form>
      <div class="header-button">
        <el-button size="small" @click="showDialog" icon="el-icon-data-analysis">开卡情况</el-button>
        <el-button type="success" size="small" @click="exportExcel">按条件导出</el-button>
        <el-button
          v-permission="['liantong:del']"
          size="mini"
          plain
          type="danger"
          :disabled="!rowCheckList.length"
          @click="batchDel"
        >批量删除
        </el-button>
        <upload-excel :permit-key="['liantong:edit']"
                      :loading.sync="loading"
                      :api="$http.importExcelHttp.importLiantongPhone"
                      @on-download="$http.exportExcelHttp.downLoadLiantongPhoneTemplate"
                      @on-success="renderTable(1)" />
      </div>
    </template>
    <!--  body  -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="phoneIccid" width="200" label="ICCID" align="center" />
      <el-table-column prop="phoneNumber" width="160" label="联通电话(迎新)" align="center" />
      <el-table-column prop="stuName" width="160" label="绑定学生姓名" />
      <!--      <el-table-column prop="stuNo" width="130" label="学号"  align="center" />-->
      <el-table-column prop="grade" width="90" label="年级" align="center" />
      <el-table-column prop="campusName" label="校区" width="120" align="center" />
      <el-table-column prop="collegeName" label="所属院系" width="160" />
      <el-table-column prop="majorName" label="专业" width="200" />
      <el-table-column prop="className" label="班级名称" width="200" />
      <el-table-column label="宿舍" min-width="200">
        <template v-slot="{row}">
            <span v-if="row.dormitoryName && row.dormitoryBedNo"
            >{{ row.dormitoryName }}{{ row.roomName }}室</span>
          <span class="font-grey" v-else-if="row.stuStatus===2">已毕业</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column width="80" fixed="right" label="操作" align="center">
        <template v-slot="{ row }">
          <el-button
            v-permission="['liantong:del']"
            size="mini"
            type="danger"
            @click="del(delLiantongPhoneApi, row.id,`号码${row.phoneNumber}${row.stuName?'(已绑定：'+row.stuName+')':''}`)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <DialogLiantongSummary ref="dialogRef"
                   :visible.sync="visibleDialog"
                   v-if="visibleDialog"/>
  </table-view>
</template>

<script>
import { delLiantongPhoneApi, pageLiantongPhoneApi } from '@/api/student'
import tableView from '@/vue/mixins/table-view'
import DialogLiantongSummary from '@/views/pages/recruitManage/liantong-phone-binding/component/DialogLiantongSummary.vue'

export default {
  name: 'LiantongPhoneBinding',
  components: { DialogLiantongSummary },
  mixins: [tableView],
  data() {
    return {
      rowCheckList: [],
      dormBuildList: [], // 宿舍楼list
      queryInfo: {
        grade: new Date().getFullYear(),
        campusId: null,
        dormitoryId: null,
        bindType: null // 是否已绑定学生
      }
    }
  },
  watch: {
    'queryInfo.campusId': function(newVal) {
      console.log(newVal)
      this.queryInfo.dormitoryId = null
      this.getDormBuild(newVal)
    }
  },
  methods: {
    delLiantongPhoneApi,
    // 获取学生列表
    async renderTable(pageNum) {
      await this.getTableData(pageLiantongPhoneApi, pageNum)
    },
    // 用户多选
    handleSelectionChange(list) {
      this.rowCheckList = []
      list.map((item) => {
        this.rowCheckList.push(item.id)
      })
    },
    // 批量删除
    async batchDel() {
      this.loading = true
      this.$confirm(`<p class="confirm-message">是否确定批量删除选中的 <b class="danger">${this.rowCheckList.length}</b> 个号码？</p>`, '批量删除号码', {
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          const _promises = []
          this.rowCheckList.forEach((item) => {
            _promises.push(() => delLiantongPhoneApi(item))
          })
          await Promise.allSettled(_promises.map(func => func()))
          this.$message.success(`已成功删除这${this.rowCheckList.length}个用户的账号！`)
          while (this.rowCheckList.length) {
            this.rowCheckList.pop()
          }
          await this.renderTable()
        } catch (e) {
          if (!e) {
            this.$message.error('删除失败，请重试~')
          }
        } finally {
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取楼栋
    async getDormBuild(campusId) {
      if (!campusId) {
        this.dormBuildList = []
        return
      }
      // 1 获取宿舍楼list
      try {
        const res = await this.$http.listDormitoryApi({ campusId })
        this.dormBuildList = res.data
      } catch (e) {
        console.error(e)
      }
    },
    // 按条件导出
    exportExcel() {
      this.$http.exportExcelHttp.exportLiantongPhone(this.queryInfo)
    }
  }
}
</script>
